import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';
import * as GUI from 'babylonjs-gui';

class Video extends BasicComponent {
    getType() { return "Video"; }

    constructor( { id } = {} ) {
        super( { id });

        this.material = undefined;
        this.texture = undefined;
        this.mesh = undefined;
        this.scene = undefined;
        this.video = undefined;
        this.prefab = undefined;
        this.context = undefined;
        this.width = undefined;
        this.height = undefined;
    }

    construct( context, prefab ) {   
        this.context = context;
        this.scene = window.scene;
        this.prefab = prefab;
        this.scaleFactor = 1;

        var base = null; 
        const video = MediaManager.getMedia(prefab.getContentID());

        //Creating Thumbnail
        if(prefab.getName()!=null && prefab.getName()!=""){
            let thumbnailID = parseInt(prefab.getName());

        console.log("Construct Video - Thumbnail = " + thumbnailID)
        console.log("Scale: " + prefab.getScale())

        base = super.construct( context, prefab ).getRootNode();
        base.position = prefab.getPosition();
        let cameraX =  this.scene.getCameraByName("MainCamera");
        let posCamera = cameraX.position;
        base.lookAt(posCamera);

        let base2 = new BABYLON.TransformNode("");
        base2.rotation.x += prefab.getRotationX() * Math.PI / 180;
        base2.rotation.y += prefab.getRotationY() * Math.PI / 180;
        base2.rotation.z += prefab.getRotationZ() * Math.PI / 180;
        base2.parent = base;

        this.width = parseInt(prefab.getWidth());
        this.height = parseInt(prefab.getHeight());

    
       // this.scene = window.scene;
        
        this.texture = MediaManager.getMedia(thumbnailID);
        //console.log(this.texture)
        const name = "VisualComponentThumbnail_"+thumbnailID;

        this.mesh = BABYLON.MeshBuilder.CreatePlane(name, { 
            width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
            height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
            sideOrientation: BABYLON.Mesh.DOUBLESIDE 
        }, window.scene);
        this.mesh.parent = base;

        this.material = new BABYLON.StandardMaterial(name + "_material", this.scene);
        this.material.emissiveTexture = this.texture.getTexture();
        this.material.emissiveTexture.uScale = -1;
        this.material.emissiveTexture.vScale = -1;
        this.material.disableLighting = true;   
        this.material.opacityTexture = this.texture.getTexture();
        this.material.opacityTexture.uScale = -1;
        this.material.opacityTexture.vScale = -1;
        this.material.emissiveTexture.hasAlpha = true;
        this.mesh.material = this.material;

        base.position = prefab.getPosition();
        //console.log(prefab.getRotation())
        this.mesh.rotation.y = Math.PI;
        this.mesh.parent = base2;
       
        this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () =>{   
            window.dispatchEvent(new CustomEvent("openURL",{detail:{url: video.getURL(),showURL: false}}));
        }));
        }
        else{ //Video Thumbnail
        // Create Base
       // const base = super.construct( context, prefab ).getRootNode();
       base = super.construct( context, prefab ).getRootNode();
        base.position = prefab.getPosition();
        let cameraX =  this.scene.getCameraByName("MainCamera");
        let posCamera = cameraX.position;
        base.lookAt(posCamera);

        let base2 = new BABYLON.TransformNode("");
        base2.rotation.x += prefab.getRotationX() * Math.PI / 180;
        base2.rotation.y += prefab.getRotationY() * Math.PI / 180;
        base2.rotation.z += prefab.getRotationZ() * Math.PI / 180;
        base2.parent = base;

        this.width = parseInt(prefab.getWidth());
        this.height = parseInt(prefab.getHeight());
        
        // Create Video
       
        let videoTexture = new BABYLON.VideoTexture("VisualComponentVideo_Video", video.getURL(), this.scene, false, false, BABYLON.TRILINEAR_SAMPLINGMODE, { 
            loop: prefab.getLooping() === "true",
            autoPlay: prefab.getAutoplay() === "true",
            autoUpdateTexture: true,
            // poster:  prefab.getPoster(), //TODO Poster from CMS
        });

        this.texture = videoTexture;
        this.video =  videoTexture.video;
        this.video.volume = prefab.getVolumeScale()/100;
        this.video.muted = this.video.volume == 0;
       
        
        // quickly play and pause video to get first frame as thumbnail
        if(this.video.paused){
            console.log("VideoSphere: fixing Chrome thumbnail");

            // muted videos can be autoplayed
            // mute and play Video to get thumbnail, 
            this.muted = true;
            let promise = this.video.play();
            
            // After play is successful pause and unmute video again
            promise.then( ()=>{
                this.video.pause();
                this.video.muted = false;
                
                // Ensure autoplay after user interaction for chrome
                if(prefab.getAutoplay() === "true"){
                    window.scene.onPointerDown = () => {
                        this.video.play();
                        window.scene.onPointerDown  = undefined;
                    }
                }
            })
        }

        // Create Material
        this.material = new BABYLON.StandardMaterial("VisualComponentVideo_VideoMaterial" + "_material", this.scene);
        this.material.emissiveTexture = this.texture;
        this.material.disableLighting = true;   
        this.material.opacityTexture = this.texture;     
        
        // Create Mesh
        this.mesh = BABYLON.MeshBuilder.CreatePlane("Video", {width:  this.width , height: this.height , sideOrientation: BABYLON.Mesh.DOUBLESIDE }, window.scene);
        this.mesh.material = this.material;
        this.mesh.rotation.y = Math.PI;
        this.mesh.parent = base2;
    
        // Create controls if checked in CMS
        if(prefab.getDisplayControls() === "true"){
            this.createControlls();
        }else{
            if(prefab.getEnlargeOnClick() === "true"){
                this.mesh.actionManager = new BABYLON.ActionManager(this.scene);

                this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () =>{   
                    window.dispatchEvent(new CustomEvent("openURL",{detail:{url: video.getURL(),showURL: false}}));
                }));
            }else{
                this.mesh.isPickable = false;
            }
        }

        base.getChildMeshes().forEach(mesh => {
            mesh.renderingGroupId = 2;
        });
        }
        return base;
    }
    

    createControlls(){
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        
        // Create  Play/Pause Button
        // shows play/pause button when you hover over the video element
        var playpauseButton = BABYLON.Mesh.CreatePlane("Play/PauseButton", 20, this.scene);
        playpauseButton.rotation.y = Math.PI;
        playpauseButton.parent =  this.mesh.parent;
        playpauseButton.setEnabled(false);
        var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(playpauseButton);
        var image = new GUI.Image("", require("@/assets/play-button.png"));
        advancedTexture.addControl(image);
        playpauseButton.isPickable = false;

        // var videoName = new GUI.TextBlock("videoName");
        // videoName.parent =  this.mesh.parent;
        // videoName.text = "abc";
        // videoName.height = "40px";
        // videoName.width = "200px";
        // advancedTexture.addControl(videoName);
        
        // Black plane before Video that will be visible when you hover over the video
        let background = BABYLON.MeshBuilder.CreatePlane("Background",{width: this.width, height: this.height ,sideOrientation: BABYLON.Mesh.DOUBLESIDE},this.scene);
        background.material = new BABYLON.StandardMaterial("", this.scene);
        background.material.diffuseColor = new BABYLON.Color3(0, 0, 0);
        background.parent = this.mesh.parent;
        background.setEnabled(false);
        background.isPickable = false;

        // videoControlls: slider/timer
        let distance = -this.height*1.38;
        let videoControllsSize = parseInt(this.width > this.height ? this.width : this.height)*1.05;
        var videoControlls = BABYLON.MeshBuilder.CreatePlane("VideoControlls", {width: videoControllsSize, height: videoControllsSize,sideOrientation: BABYLON.Mesh.DOUBLESIDE}, this.scene);
        videoControlls.parent = this.mesh.parent;
        videoControlls.position.y = distance;
        videoControlls.position.z = 5;
        videoControlls.rotation.y = Math.PI;

        var advancedTexture2 = GUI.AdvancedDynamicTexture.CreateForMesh(videoControlls);
        
        var rect1 = new GUI.Rectangle();
        rect1.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        rect1.top = "60px";
        rect1.height = "100px";
        rect1.cornerRadius = 10;
        rect1.thickness = 0;
        rect1.background = rect1.color = "#333333";
        advancedTexture2.addControl(rect1);    

        var grid = new GUI.Grid();   
        grid.addColumnDefinition(1);
        grid.addRowDefinition(20,true);
        grid.addRowDefinition(0.5);
        rect1.addControl(grid); 

        var minColWidth = 0.06;
        var seperatorWidth = 1 - (minColWidth*11.5);
        var gridControls = new GUI.Grid();
        gridControls.addColumnDefinition(minColWidth*1.5);
        gridControls.addColumnDefinition(minColWidth*2);
        gridControls.addColumnDefinition(minColWidth*3);
        gridControls.addColumnDefinition(minColWidth*3);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.addColumnDefinition(seperatorWidth);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.paddingLeft = "20px";
        gridControls.paddingRight = "20px";
        grid.addControl(gridControls,1,0);


        // Zeitleiste
        var sliderUI = new GUI.Slider();
        sliderUI.hoverCursor = "pointer";
        sliderUI.value = 0;
        sliderUI.minimum = 0;
        sliderUI.maximum = 1;
        this.video.onloadedmetadata = function() { sliderUI.maximum = this.duration;};
        sliderUI.height = "20px";
        sliderUI.barOffset = "0px";
        sliderUI.isThumbCircle = true; 
        sliderUI.isThumbClamped = true;
        sliderUI.thumbColor = this.context.primaryColor;
        sliderUI.borderColor = this.context.primaryColor;
        sliderUI.background = "#111111";
        sliderUI.color = this.context.primaryColor;
        grid.addControl(sliderUI,0,0); 
        
        //Play/Pause Button 
        var playpauseButton2 = new GUI.Button("playPauseBtn2");
        playpauseButton2.hoverCursor = "pointer";
        playpauseButton2.thickness = 0;
        var playpauseButton2Img = new GUI.Image("",require("@/assets/pause.svg"));
        playpauseButton2.width = "48px";
        playpauseButton2.height = "48px";
        playpauseButton2.addControl(playpauseButton2Img);
        gridControls.addControl(playpauseButton2, 0, 0);

        // Sound Button
        var soundBtn = new GUI.Button("soundBtn");
        soundBtn.hoverCursor = "pointer";
        soundBtn.thickness = 0;
        var soundImage =  new GUI.Image("", this.video.muted ? require("@/assets/volume_off_white_24dp.svg") : require("@/assets/volume_up_white_24dp.svg"));
        soundImage.width = "48px";
        soundImage.height = "48px";
        soundBtn.addControl(soundImage);
        gridControls.addControl(soundBtn, 0, 1);
        
        //Volume Slider
        var volumeSlider = new GUI.Slider("volumeSlider");
        volumeSlider.hoverCursor = "pointer";
        volumeSlider.value = this.video.volume;
        volumeSlider.minimum = 0;
        volumeSlider.maximum = 1;
        volumeSlider.height = "14px";
        volumeSlider.barOffset = "0px";
        volumeSlider.isThumbCircle = true; 
        volumeSlider.isThumbClamped = true;
        volumeSlider.thumbColor = this.context.primaryColor;
        volumeSlider.borderColor = this.context.primaryColor;
        volumeSlider.background = "#111111";
        volumeSlider.color = this.context.primaryColor;
        gridControls.addControl(volumeSlider,0,2)


        //Video Laufzeit Text
        var time = new GUI.TextBlock();
        // time.fontFamily = this.context.fontFamily;
        time.left = "28px";
        time.text = "0:00/0:00";
        time.color = "#ffffff";
        time.fontSize = 26;
        time.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        time.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        gridControls.addControl(time, 0, 3);

        //Popup Video Window
        var openWindowBtn = new GUI.Button("openWindow");
        openWindowBtn.hoverCursor = "pointer";
        openWindowBtn.thickness = 0;
        var openWindowBtnImg = new GUI.Image("",require("@/assets/web_asset.svg"));
        openWindowBtn.width = "48px";
        openWindowBtn.height = "48px";
        openWindowBtn.addControl(openWindowBtnImg);
        gridControls.addControl(openWindowBtn, 0, 8);


        this.mesh.actionManager = new BABYLON.ActionManager(this.scene);


        // INTERACTIONS ------------------------------
        let drag = false;
        let volDrag = false;

        var volumeValue = 0;

        // Open Video Gallery inside Pop-Up
        openWindowBtn.onPointerClickObservable.add(() => {
            this.video.pause();
            window.dispatchEvent(new CustomEvent("openVideo",{detail:{time: this.video.currentTime, videoURL: this.video.src, name: this.prefab.getName()}}));
        });

        // When user starts dragging pause video
        // Detach camera otherwise camera will move while dragging the slider
        sliderUI.onPointerDownObservable.add(() => {
            drag = true;
            this.scene.getCameraByName("MainCamera").detachControl();
            this.video.pause();
        });    

        // When user stops dragging play video
        // attach camera again
        sliderUI.onPointerUpObservable.add(() => {
            drag = false;
            this.scene.getCameraByName("MainCamera").attachControl(document.getElementById("renderCanvas"), true, false,4);
            this.video.currentTime = sliderUI.value;
            time.text = this.updateTime();
            this.video.play();
        });
        
        // Volume Behavior
        soundBtn.onPointerClickObservable.add( () => {
            if(!this.video.muted){
                soundBtn.removeControl(soundImage);
                soundImage.source = require("@/assets/volume_off_white_24dp.svg");
                soundBtn.addControl(soundImage);
                volumeSlider.value = 0;
            } else {
                soundBtn.removeControl(soundImage);
                soundImage.source = require("@/assets/volume_up_white_24dp.svg");
                soundBtn.addControl(soundImage);
                if(volumeValue < 0.01){
                    volumeSlider.value = 1;
                } else {
                    volumeSlider.value = volumeValue;
                }
            }
            this.video.volume = volumeSlider.value;
            this.video.muted = !this.video.muted;
        });


        volumeSlider.onPointerDownObservable.add(() => {
            volDrag = true;
            this.scene.getCameraByName("MainCamera").detachControl();
        });
        volumeSlider.onPointerUpObservable.add(() => {
            volDrag = false;
            this.scene.getCameraByName("MainCamera").attachControl(document.getElementById("renderCanvas"), true, false,4);
            this.video.volume = volumeSlider.value;
            if(this.video.volume != 0){
                soundBtn.removeControl(soundImage);
                soundImage.source = require("@/assets/volume_up_white_24dp.svg");
                soundBtn.addControl(soundImage);
                this.video.muted = false;
            }
        }); 
        volumeSlider.onPointerMoveObservable.add(() => {
            if(volDrag){
                document.getElementById("renderCanvas").style.cursor = "pointer";
                this.video.volume = volumeSlider.value;
                if(volumeSlider.value == 0){
                    soundBtn.removeControl(soundImage);
                    soundImage.source = require("@/assets/volume_off_white_24dp.svg");
                    soundBtn.addControl(soundImage);
                    this.video.muted = true;
                } else {
                    if(this.video.muted){
                        soundBtn.removeControl(soundImage);
                        soundImage.source = require("@/assets/volume_up_white_24dp.svg");
                        soundBtn.addControl(soundImage);
                        this.video.muted = false;
                    }
                    volumeValue = volumeSlider.value;
                }
            }
        }); 

        // change currentTime of video when user is dragging the slider 
        // changing cursor to pointer because the cursor somehow changes to default when dragging
        sliderUI.onPointerMoveObservable.add(() => {
            if(drag){
                document.getElementById("renderCanvas").style.cursor = "pointer";
                this.video.currentTime = sliderUI.value;
                time.text = this.updateTime();
            }
        });    

        // Refresh slider value when currentTime of video changes
        // Dont update slider when user interacts with it
        this.video.ontimeupdate = () =>{
            if(!drag){
                time.text = this.updateTime();
                sliderUI.value = this.video.currentTime;
            }
        };
        
        // Switch pause to play Button when video is playing
        this.video.onplay = function() {
            advancedTexture.removeControl(image);
            image = new GUI.Image("", require("@/assets/pause-button.png"));
            advancedTexture.addControl(image);
            playpauseButton2.removeControl(playpauseButton2Img);
            playpauseButton2Img = new GUI.Image("",require("@/assets/pause.svg"));
            playpauseButton2.addControl(playpauseButton2Img);
        };

        // Switch play to pause Button when video is paused
        this.video.onpause = function() {
            advancedTexture.removeControl(image);
            image = new GUI.Image("", require("@/assets/play-button.png"));
            advancedTexture.addControl(image);
            playpauseButton2.removeControl(playpauseButton2Img);
            playpauseButton2Img = new GUI.Image("",require("@/assets/play.svg"));
            playpauseButton2.addControl(playpauseButton2Img);
        };

        // Click: play/pause video
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () =>{   
            this.video.paused ? this.video.play() : this.video.pause();
        }));

        playpauseButton2.onPointerClickObservable.add(()=>{
            this.video.paused ? this.video.play() : this.video.pause();
        })
        
        // hover out: Hide play/pause Button
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){  
            BABYLON.Animation.CreateAndStartAnimation("", playpauseButton, "visibility", 10,2, playpauseButton.visibility, 0, 0, ease, function(){ 
                playpauseButton.setEnabled(false);
            })       
            BABYLON.Animation.CreateAndStartAnimation("", background, "visibility", 10,2, background.visibility, 0, 0, ease, function(){ 
                background.setEnabled(false);
            })     
        }));
        
        // hover over: Display play/pause Button
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
            playpauseButton.setEnabled(true);
            BABYLON.Animation.CreateAndStartAnimation("", playpauseButton, "visibility", 10,2, 0, 1, 0, ease);
            background.setEnabled(true);
            BABYLON.Animation.CreateAndStartAnimation("", background, "visibility", 10,2, 0, 0.7, 0, ease);
        }));
    }

    updateTime(){ 
        let currenTime =  this.formatTime(this.video.currentTime);
        let duration = this.formatTime(this.video.duration);
        return currenTime + "/" + duration;
    }

    formatTime(time){
        var mins = Math.floor(time / 60);
        var secs = Math.floor(time - mins * 60);
        return mins + ":" + (secs < 10 ? "0" : "") + secs;
    }
    
    enable(){
        super.enable();    
        if(this.prefab.getAutoplay() ==="true" && this.video)
            this.video.play();
    }

    disable(){
        super.disable();
        if(this.video)
            this.video.pause();
    }

}

export default Video;

